// Function Data
;
//# sourceMappingURL=angular2-token.model.js.map


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/~/angular2-token/lib/angular2-token.model.js
// module id = ../../../../angular2-token/lib/angular2-token.model.js
// module chunks = 3